export default __webpack_public_path__ + "static/media/dashboard-button-applications.0847ca22.png";